var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPeople = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81802 15.818C2.66193 14.9741 3.80653 14.5 5 14.5H13C14.1935 14.5 15.3381 14.9741 16.182 15.818C17.0259 16.6619 17.5 17.8065 17.5 19V21C17.5 21.2761 17.2761 21.5 17 21.5C16.7239 21.5 16.5 21.2761 16.5 21V19C16.5 18.0717 16.1313 17.1815 15.4749 16.5251C14.8185 15.8687 13.9283 15.5 13 15.5H5C4.07174 15.5 3.1815 15.8687 2.52513 16.5251C1.86875 17.1815 1.5 18.0717 1.5 19V21C1.5 21.2761 1.27614 21.5 1 21.5C0.723858 21.5 0.5 21.2761 0.5 21V19C0.5 17.8065 0.974106 16.6619 1.81802 15.818Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.5C7.067 3.5 5.5 5.067 5.5 7C5.5 8.933 7.067 10.5 9 10.5C10.933 10.5 12.5 8.933 12.5 7C12.5 5.067 10.933 3.5 9 3.5ZM4.5 7C4.5 4.51472 6.51472 2.5 9 2.5C11.4853 2.5 13.5 4.51472 13.5 7C13.5 9.48528 11.4853 11.5 9 11.5C6.51472 11.5 4.5 9.48528 4.5 7Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5159 15.004C19.5849 14.7367 19.8576 14.5759 20.125 14.6449C21.0904 14.8942 21.9457 15.457 22.5565 16.245C23.1674 17.033 23.4993 18.0016 23.5 18.9987L23.5 18.999V20.999C23.5 21.2752 23.2761 21.499 23 21.499C22.7239 21.499 22.5 21.2752 22.5 20.999L22.5 18.9994C22.5 18.9993 22.5 18.9992 22.5 18.9991C22.5 18.9991 22.5 18.9991 22.5 18.999C22.4993 18.2237 22.2412 17.4705 21.7662 16.8577C21.2911 16.2448 20.6259 15.807 19.875 15.6132C19.6076 15.5441 19.4468 15.2714 19.5159 15.004Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5156 3.00501C15.5841 2.73749 15.8565 2.57616 16.124 2.64465C17.092 2.89249 17.9499 3.45544 18.5626 4.24475C19.1753 5.03406 19.5078 6.00483 19.5078 7.00403C19.5078 8.00322 19.1753 8.97399 18.5626 9.7633C17.9499 10.5526 17.092 11.1156 16.124 11.3634C15.8565 11.4319 15.5841 11.2706 15.5156 11.003C15.4471 10.7355 15.6085 10.4631 15.876 10.3947C16.6288 10.2019 17.2961 9.76404 17.7727 9.15013C18.2492 8.53622 18.5078 7.78118 18.5078 7.00403C18.5078 6.22688 18.2492 5.47183 17.7727 4.85792C17.2961 4.24401 16.6288 3.80616 15.876 3.6134C15.6085 3.54491 15.4471 3.27252 15.5156 3.00501Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPeople);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/people.85feb0bcab704222cd9cdc2504807625.svg";